import React from 'react';
import ReactDOM from 'react-dom';

import * as Sentry from '@sentry/browser';
import singleSpaReact from 'single-spa-react';

import ErrorBoundaryView from './auto/components/ErrorBoundaryView';
import Root from './Root';
import '@sureapp/wl-toggle-common/dist/togglewind.css';
import './common/styles/base.css';
import './toggle-auto-variables.css';

Sentry.setTag('partner', process.env.REACT_APP_TENANT);
// Tenants like toyota rely on global styles from this file that better doesn't need.
// TODO - Move those global into a generic file to be used across all tenants.
if (process.env.REACT_APP_TENANT !== 'better') {
  import('@sureapp/wl-toggle-common/dist/toggle-default-variables.css');
}

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Root,
  errorBoundary(err, info, props) {
    console.log(err);
    console.log(info);
    console.log(props);

    // Customize the root error boundary for your microfrontend here.
    return <ErrorBoundaryView />;
  },
});

export const { bootstrap, mount, unmount } = lifecycles;
